import { createElementBlock as t, openBlock as n, createElementVNode as l } from "vue";
const o = {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-appleinc"
};
function c(i, e) {
  return n(), t("svg", o, e[0] || (e[0] = [
    l("path", {
      d: "M11.2315 15.8581C10.3605 16.7024 9.40955 16.5691 8.49411 16.1691C7.52534 15.7603 6.63656 15.7425 5.61447 16.1691C4.33463 16.7202 3.65916 16.5602 2.89482 15.8581C-1.44242 11.3875 -0.802496 4.5795 4.12133 4.33064C5.32118 4.39285 6.15663 4.98833 6.85876 5.04166C7.90752 4.82835 8.91183 4.2151 10.0317 4.29509C11.3737 4.40174 12.387 4.93501 13.0535 5.89489C10.2806 7.5569 10.9382 11.2098 13.4801 12.2319C12.9735 13.565 12.3158 14.8893 11.2227 15.867L11.2315 15.8581ZM6.76988 4.27731C6.63656 2.29534 8.24525 0.659992 10.0939 0.500012C10.3517 2.79306 8.01417 4.49951 6.76988 4.27731Z",
      fill: "black"
    }, null, -1)
  ]));
}
const C = { render: c };
export {
  C as default,
  c as render
};
